import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tbdc-footermenu" }
const _hoisted_2 = {
  id: "tbdc-bottomtoolbar",
  class: "tbdc-elevation-5"
}
const _hoisted_3 = { id: "tbdc-bottomtoolbar-position" }
const _hoisted_4 = { class: "tbdc-floatingmenubutton" }
const _hoisted_5 = { class: "tbdc-legend-panel" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_MapLegend = _resolveComponent("MapLegend")!
  const _component_OutputLegend = _resolveComponent("OutputLegend")!
  const _component_AreaLegend = _resolveComponent("AreaLegend")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_Pegman = _resolveComponent("Pegman")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_menu, {
          ref: "legendMenu",
          location: "top",
          "close-on-click": true,
          "close-on-content-click": false,
          "content-class": "tbdc-floatingmenucontent"
        }, {
          activator: _withCtx(({ props: menuProps }) => [
            _createVNode(_component_v_tooltip, {
              location: "top",
              "open-delay": "250",
              "open-on-hover": true
            }, {
              activator: _withCtx(({ props: tooltipProps }) => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_v_btn, _mergeProps({
                    icon: "",
                    variant: "text"
                  }, _ctx.mergeProps(menuProps, tooltipProps), {
                    disabled: !$options.hasLegend
                  }), {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                          _createTextVNode("mdi-layers-search-outline", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 16, ["disabled"])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("message.legend")), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              ($props.legendData && $props.legendData.length > 0)
                ? (_openBlock(), _createBlock(_component_MapLegend, {
                    key: 0,
                    data: $props.legendData
                  }, null, 8, ["data"]))
                : _createCommentVNode("", true),
              ($props.showLocationOutput && $props.outputLegendData)
                ? (_openBlock(), _createBlock(_component_OutputLegend, {
                    key: 1,
                    data: $props.outputLegendData
                  }, null, 8, ["data"]))
                : _createCommentVNode("", true),
              ($props.areaLegendData)
                ? (_openBlock(), _createBlock(_component_AreaLegend, {
                    key: 2,
                    data: $props.areaLegendData
                  }, null, 8, ["data"]))
                : _createCommentVNode("", true),
              ($props.rasterLegendData)
                ? (_openBlock(), _createBlock(_component_AreaLegend, {
                    key: 3,
                    data: $props.rasterLegendData
                  }, null, 8, ["data"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 512)
      ])
    ]),
    ($setup.map && $setup.scaleControl)
      ? (_openBlock(), _createBlock(_component_Pegman, {
          key: 0,
          mapValue: $setup.map,
          scaleControlValue: $setup.scaleControl
        }, null, 8, ["mapValue", "scaleControlValue"]))
      : _createCommentVNode("", true)
  ]))
}